import React from "react";
import sanitizeHtml from "sanitize-html";

export const SanitizedHTML = ({ unsafeHTML }: { unsafeHTML: string }) => {
  const clean = sanitizeHtml(unsafeHTML, {
    allowedTags: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "br",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
    ],
    allowedAttributes: {
      a: ["href", "target"],
    },
  });

  return <div dangerouslySetInnerHTML={{ __html: clean }} />;
};
